import * as AppActions from "./appActions";
import api from '../../utils/api';

export const ACTION_COURSE_ADDED = 'ACTION_COURSE_ADDED';
export const ACTION_COURSE_ADD_FAILED = 'ACTION_COURSE_ADD_FAILED';
export const ACTION_COURSE_RETRIEVED = 'ACTION_COURSE_RETRIEVED';
export const ACTION_COURSE_REQUESTED = 'ACTION_COURSE_REQUESTED';

// Subjects
export const ACTION_COURSE_SUBJECT_ADDED = 'ACTION_COURSE_SUBJECT_ADDED';
export const ACTION_COURSE_SUBJECT_ADD_FAILED = 'ACTION_COURSE_SUBJECT_ADD_FAILED';
export const ACTION_COURSE_SUBJECT_RETRIEVED = 'ACTION_COURSE_SUBJECT_RETRIEVED';
export const ACTION_COURSE_SUBJECT_REQUESTED = 'ACTION_COURSE_SUBJECT_REQUESTED';
export const ACTION_COURSE_SUBJECT_UPDATED = 'ACTION_COURSE_SUBJECT_UPDATED';
export const ACTION_COURSE_SUBJECT_UPDATE_FAILED = 'ACTION_COURSE_SUBJECT_UPDATE_FAILED';

// Chapters
export const ACTION_COURSE_CHAPTER_ADDED = 'ACTION_COURSE_CHAPTER_ADDED';
export const ACTION_COURSE_CHAPTER_ADD_FAILED = 'ACTION_COURSE_CHAPTER_ADD_FAILED';
export const ACTION_COURSE_CHAPTER_RETRIEVED = 'ACTION_COURSE_CHAPTER_RETRIEVED';
export const ACTION_COURSE_CHAPTER_REQUESTED = 'ACTION_COURSE_CHAPTER_REQUESTED';

// Lectures
export const ACTION_LECTURE_ADDED = 'ACTION_LECTURE_ADDED';
export const ACTION_LECTURE_ADD_FAILED = 'ACTION_LECTURE_ADD_FAILED';
export const ACTION_LECTURES_REQUESTED = 'ACTION_LECTURES_REQUESTED';
export const ACTION_LECTURES_RETRIEVED = 'ACTION_LECTURES_RETRIEVED';

/**
 * Courses
 * @param course
 * @returns {{type: string, payload: *}}
 */

export function courseAdded(course){
    return {
        type: ACTION_COURSE_ADDED,
        payload: course
    };
}

export function courseAddFailed(res){
    return {
        type: ACTION_COURSE_ADD_FAILED
    }
}

export function coursesRetrieved(res){
    return {
        type: ACTION_COURSE_RETRIEVED,
        payload: res
    }
}

export function getCourses(uid){
    return (dispatch) => {
        api.getCourses(uid, (res) => {
           dispatch(coursesRetrieved(res.data));
        });
    }
}

/**
 * Course Subjects
 * @param subject
 * @returns {{type: string, payload: *}}
 * @constructor
 */

function CourseSubjectAdded(subject){
    return {
        type: ACTION_COURSE_SUBJECT_ADDED,
        payload: subject
    }
}

function CourseSubjectAddFailed(res){
    return {
        type: ACTION_COURSE_SUBJECT_ADD_FAILED
    }
}

function CourseSubjectUpdated(data){
    return {
        type: ACTION_COURSE_SUBJECT_UPDATED,
        payload: data
    }
}

function CourseSubjectUpdateFailed(data){
    return {
        type: ACTION_COURSE_SUBJECT_UPDATE_FAILED
    }
}

function courseSubjectsRetrieved(subjects){
    return {
        type: ACTION_COURSE_SUBJECT_RETRIEVED,
        payload: subjects
    }
}

function courseSubjectsRequested(){
    return {
        type: ACTION_COURSE_SUBJECT_REQUESTED
    }
}

function CourseChapterAdded(chapter){
    return {
        type: ACTION_COURSE_CHAPTER_ADDED,
        payload: chapter
    }
}

function CourseChapterAddFailed(data){
    return {
        type: ACTION_COURSE_CHAPTER_ADD_FAILED
    }
}

function CourseChaptersRetrieved(chapters){
    return {
        type: ACTION_COURSE_CHAPTER_RETRIEVED,
        payload: chapters
    }
}

function CourseChaptersRequested(){
    return {
        type: ACTION_COURSE_CHAPTER_REQUESTED
    }
}

export function getCourseSubjects(courseId){
    return (dispatch) => {
        dispatch(courseSubjectsRequested());
        api.getCourseSubjects(courseId, res => {
            dispatch(courseSubjectsRetrieved(res.data));
        });
    }
}

export function addCourse(name, slug, token){

    return (dispatch) => {

        api.addCourse({name: name, slug: slug, owner: token}, token, (res) => {
            if(res.status === 200){
                dispatch(courseAdded(res.data));
            }else{
                dispatch(courseAddFailed(res));
            }
        })
    }
}

export function getChart(courseId, view, length, token){
    return dispatch => {
        dispatch({
            type: 'CLEAR_CHART'
        });

        api.getChart(courseId, view, length, token)
    }
}

export function addCourseSubject(name, slug, description, courseId, token){
    return (dispatch) => {
        api.addCourseSubject({name: name, slug: slug, description: description, courseId: courseId, owner: token, chapters: []}, res => {
            if(res.status === 200){
                dispatch(CourseSubjectAdded(res.data));
            }else{
                dispatch(CourseSubjectAddFailed(res));
            }
        })
    }
}

export function saveSubject(sub, token){
    return (dispatch) => {
        api.updateCourseSubject(sub, res => {
            if(res.status === 200){
                dispatch(CourseSubjectUpdated(res.data));
            }else{
                dispatch(CourseSubjectUpdateFailed(res));
            }
        })
    }
}

export function getChapters(subjectId){
    return (dispatch) => {
        dispatch(CourseChaptersRequested());
        api.getSubjectChapters(subjectId, res => {
            if(res.status === 200){
                dispatch(CourseChaptersRetrieved(res.data));
            }
        })
    }
}

export function addChapter(number, name, slug, description, subjectId){
    return (dispatch) => {
        api.addSubjectChapter({number: number, name: name, slug: slug, description: description, subjectId: subjectId}, res => {
            if(res.status === 200){
                dispatch(CourseChapterAdded(res.data));
            }else{
                dispatch(CourseChapterAddFailed(res));
            }
        })
    }
}

export function addLecture(lecture){
    return (dispatch) => {

    }
}



// WEBPACK FOOTER //
// ./src/store/actions/courseActions.js